<template>
  <div>
    <div class="product-add">
      <!--form表单-->
      <el-form size="small" label-width="150px">
        <div class="common-form">退费设置</div>
        <el-form-item label="项目退款比例">
          <el-input v-model="obj.waiterReachNoStart" placeholder="技师已到达，未开始服务，扣路费，项目退款比例" class="max-w460"></el-input>%
        </el-form-item>
        <el-form-item label="退款额度">
          <el-input v-model="obj.waiterReachIsStart" placeholder="技师到达并开始服务，根据设定的多少分钟，进行退款" class="max-w460"></el-input>%
        </el-form-item>
        <el-form-item label="退款最高时间（分钟）">
          <el-input v-model="obj.waiterReachIsStart_time" placeholder="超出时间概不退款（单位分钟）" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="服务完成退款比例">
          <el-input v-model="obj.waiterServiceCompletion" placeholder="服务完成后申请退款，扣路费，退款比例" class="max-w460"></el-input>%
        </el-form-item>
        <el-form-item label="加种项目退款比例">
          <el-input v-model="obj.addClockOrder" placeholder="加种项目退款比例" class="max-w460"></el-input>%
        </el-form-item>
      </el-form>
    </div>
    <div class="common-button-wrapper">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import fareApi from "@/api/fare.js";
export default {
  data() {
    return {
      obj: {}
    };
  },
  created() {
    this.getDate();
  },
  methods: {
    getDate() {
      let self = this;
      fareApi
        .Refundindex({}, true)
        .then(res => {
          self.obj = res.data;
        })
        .catch(err => {});
    },
    onSubmit() {
      let self = this;
      fareApi
        .Refundedit(self.obj, true)
        .then(res => {
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "success"
            });
          }
          console.log(res);
        })
        .catch(err => {
          this.$message({
            message: err.msg,
            type: "warning"
          });
        });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/setting/refund/index.vue